var Gr = Object.defineProperty, Ur = Object.defineProperties;
var Xr = Object.getOwnPropertyDescriptors;
var E = Object.getOwnPropertySymbols;
var Z = Object.prototype.hasOwnProperty, J = Object.prototype.propertyIsEnumerable;
var rr = Math.pow, Q = (r, e, t) => e in r ? Gr(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, p = (r, e) => {
  for (var t in e || (e = {}))
    Z.call(e, t) && Q(r, t, e[t]);
  if (E)
    for (var t of E(e))
      J.call(e, t) && Q(r, t, e[t]);
  return r;
}, x = (r, e) => Ur(r, Xr(e));
var A = (r, e) => {
  var t = {};
  for (var n in r)
    Z.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && E)
    for (var n of E(r))
      e.indexOf(n) < 0 && J.call(r, n) && (t[n] = r[n]);
  return t;
};
import { useContext as V, createContext as fr, useMemo as Yr, useId as Kr, forwardRef as I } from "react";
import { jsx as $, jsxs as Qr, Fragment as Zr } from "react/jsx-runtime";
import { r as i } from "./rem-CMQJ_ZTp.js";
function q(r) {
  return Object.keys(r);
}
function F(r) {
  return r && typeof r == "object" && !Array.isArray(r);
}
function cr(r, e) {
  const t = p({}, r), n = e;
  return F(r) && F(e) && Object.keys(e).forEach((a) => {
    F(n[a]) && a in r ? t[a] = cr(t[a], n[a]) : t[a] = n[a];
  }), t;
}
function Jr(r) {
  return r.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
}
function pr(r) {
  return Object.keys(r).reduce((e, t) => (r[t] !== void 0 && (e[t] = r[t]), e), {});
}
function re(r) {
  if (typeof r == "number")
    return !0;
  if (typeof r == "string") {
    if (r.startsWith("calc(") || r.startsWith("var(") || r.includes(" ") && r.trim() !== "")
      return !0;
    const e = /^[+-]?[0-9]+(\.[0-9]+)?(px|em|rem|ex|ch|lh|rlh|vw|vh|vmin|vmax|vb|vi|svw|svh|lvw|lvh|dvw|dvh|cm|mm|in|pt|pc|q|cqw|cqh|cqi|cqb|cqmin|cqmax|%)?$/;
    return r.trim().split(/\s+/).every((n) => e.test(n));
  }
  return !1;
}
function lr(r) {
  var e, t, n = "";
  if (typeof r == "string" || typeof r == "number") n += r;
  else if (typeof r == "object") if (Array.isArray(r)) {
    var a = r.length;
    for (e = 0; e < a; e++) r[e] && (t = lr(r[e])) && (n && (n += " "), n += t);
  } else for (t in r) r[t] && (n && (n += " "), n += t);
  return n;
}
function ee() {
  for (var r, e, t = 0, n = "", a = arguments.length; t < a; t++) (r = arguments[t]) && (e = lr(r)) && (n && (n += " "), n += e);
  return n;
}
const te = fr(null);
function b() {
  const r = V(te);
  if (!r)
    throw new Error("[@mantine/core] MantineProvider was not found in tree");
  return r;
}
function Ue() {
  return b().cssVariablesResolver;
}
function Xe() {
  return b().classNamesPrefix;
}
function ne() {
  return b().getStyleNonce;
}
function Ye() {
  return b().withStaticClasses;
}
function Ke() {
  return b().headless;
}
function oe() {
  var r;
  return (r = b().stylesTransform) == null ? void 0 : r.sx;
}
function Qe() {
  var r;
  return (r = b().stylesTransform) == null ? void 0 : r.styles;
}
function Ze() {
  return b().env || "default";
}
function ie(r) {
  return /^#?([0-9A-F]{3}){1,2}([0-9A-F]{2})?$/i.test(r);
}
function ae(r) {
  let e = r.replace("#", "");
  if (e.length === 3) {
    const s = e.split("");
    e = [
      s[0],
      s[0],
      s[1],
      s[1],
      s[2],
      s[2]
    ].join("");
  }
  if (e.length === 8) {
    const s = parseInt(e.slice(6, 8), 16) / 255;
    return {
      r: parseInt(e.slice(0, 2), 16),
      g: parseInt(e.slice(2, 4), 16),
      b: parseInt(e.slice(4, 6), 16),
      a: s
    };
  }
  const t = parseInt(e, 16), n = t >> 16 & 255, a = t >> 8 & 255, o = t & 255;
  return {
    r: n,
    g: a,
    b: o,
    a: 1
  };
}
function se(r) {
  const [e, t, n, a] = r.replace(/[^0-9,./]/g, "").split(/[/,]/).map(Number);
  return { r: e, g: t, b: n, a: a === void 0 ? 1 : a };
}
function fe(r) {
  const e = /^hsla?\(\s*(\d+)\s*,\s*(\d+%)\s*,\s*(\d+%)\s*(,\s*(0?\.\d+|\d+(\.\d+)?))?\s*\)$/i, t = r.match(e);
  if (!t)
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    };
  const n = parseInt(t[1], 10), a = parseInt(t[2], 10) / 100, o = parseInt(t[3], 10) / 100, s = t[5] ? parseFloat(t[5]) : void 0, f = (1 - Math.abs(2 * o - 1)) * a, c = n / 60, l = f * (1 - Math.abs(c % 2 - 1)), y = o - f / 2;
  let d, u, m;
  return c >= 0 && c < 1 ? (d = f, u = l, m = 0) : c >= 1 && c < 2 ? (d = l, u = f, m = 0) : c >= 2 && c < 3 ? (d = 0, u = f, m = l) : c >= 3 && c < 4 ? (d = 0, u = l, m = f) : c >= 4 && c < 5 ? (d = l, u = 0, m = f) : (d = f, u = 0, m = l), {
    r: Math.round((d + y) * 255),
    g: Math.round((u + y) * 255),
    b: Math.round((m + y) * 255),
    a: s || 1
  };
}
function G(r) {
  return ie(r) ? ae(r) : r.startsWith("rgb") ? se(r) : r.startsWith("hsl") ? fe(r) : {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}
function z(r, e) {
  if (r.startsWith("var("))
    return `color-mix(in srgb, ${r}, black ${e * 100}%)`;
  const { r: t, g: n, b: a, a: o } = G(r), s = 1 - e, f = (c) => Math.round(c * s);
  return `rgba(${f(t)}, ${f(n)}, ${f(a)}, ${o})`;
}
function ce(r, e) {
  return typeof r.primaryShade == "number" ? r.primaryShade : e === "dark" ? r.primaryShade.dark : r.primaryShade.light;
}
function N(r) {
  return r <= 0.03928 ? r / 12.92 : rr((r + 0.055) / 1.055, 2.4);
}
function pe(r) {
  const e = r.match(/oklch\((.*?)%\s/);
  return e ? parseFloat(e[1]) : null;
}
function le(r) {
  if (r.startsWith("oklch("))
    return (pe(r) || 0) / 100;
  const { r: e, g: t, b: n } = G(r), a = e / 255, o = t / 255, s = n / 255, f = N(a), c = N(o), l = N(s);
  return 0.2126 * f + 0.7152 * c + 0.0722 * l;
}
function S(r, e = 0.179) {
  return r.startsWith("var(") ? !1 : le(r) > e;
}
function _({
  color: r,
  theme: e,
  colorScheme: t
}) {
  if (typeof r != "string")
    throw new Error(
      `[@mantine/core] Failed to parse color. Expected color to be a string, instead got ${typeof r}`
    );
  if (r === "bright")
    return {
      color: r,
      value: t === "dark" ? e.white : e.black,
      shade: void 0,
      isThemeColor: !1,
      isLight: S(
        t === "dark" ? e.white : e.black,
        e.luminanceThreshold
      ),
      variable: "--mantine-color-bright"
    };
  if (r === "dimmed")
    return {
      color: r,
      value: t === "dark" ? e.colors.dark[2] : e.colors.gray[7],
      shade: void 0,
      isThemeColor: !1,
      isLight: S(
        t === "dark" ? e.colors.dark[2] : e.colors.gray[6],
        e.luminanceThreshold
      ),
      variable: "--mantine-color-dimmed"
    };
  if (r === "white" || r === "black")
    return {
      color: r,
      value: r === "white" ? e.white : e.black,
      shade: void 0,
      isThemeColor: !1,
      isLight: S(
        r === "white" ? e.white : e.black,
        e.luminanceThreshold
      ),
      variable: `--mantine-color-${r}`
    };
  const [n, a] = r.split("."), o = a ? Number(a) : void 0, s = n in e.colors;
  if (s) {
    const f = o !== void 0 ? e.colors[n][o] : e.colors[n][ce(e, t || "light")];
    return {
      color: n,
      value: f,
      shade: o,
      isThemeColor: s,
      isLight: S(f, e.luminanceThreshold),
      variable: a ? `--mantine-color-${n}-${o}` : `--mantine-color-${n}-filled`
    };
  }
  return {
    color: r,
    value: r,
    isThemeColor: s,
    isLight: S(r, e.luminanceThreshold),
    shade: o,
    variable: void 0
  };
}
function er(r, e) {
  const t = _({ color: r || e.primaryColor, theme: e });
  return t.variable ? `var(${t.variable})` : r;
}
function tr(r, e) {
  var o, s;
  const t = {
    from: (r == null ? void 0 : r.from) || e.defaultGradient.from,
    to: (r == null ? void 0 : r.to) || e.defaultGradient.to,
    deg: (s = (o = r == null ? void 0 : r.deg) != null ? o : e.defaultGradient.deg) != null ? s : 0
  }, n = er(t.from, e), a = er(t.to, e);
  return `linear-gradient(${t.deg}deg, ${n} 0%, ${a} 100%)`;
}
function g(r, e) {
  if (typeof r != "string" || e > 1 || e < 0)
    return "rgba(0, 0, 0, 1)";
  if (r.startsWith("var(")) {
    const o = (1 - e) * 100;
    return `color-mix(in srgb, ${r}, transparent ${o}%)`;
  }
  if (r.startsWith("oklch"))
    return r.includes("/") ? r.replace(/\/\s*[\d.]+\s*\)/, `/ ${e})`) : r.replace(")", ` / ${e})`);
  const { r: t, g: n, b: a } = G(r);
  return `rgba(${t}, ${n}, ${a}, ${e})`;
}
const Je = g, de = ({
  color: r,
  theme: e,
  variant: t,
  gradient: n,
  autoContrast: a
}) => {
  const o = _({ color: r, theme: e }), s = typeof a == "boolean" ? a : e.autoContrast;
  if (t === "filled") {
    const f = s && o.isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)";
    return o.isThemeColor ? o.shade === void 0 ? {
      background: `var(--mantine-color-${r}-filled)`,
      hover: `var(--mantine-color-${r}-filled-hover)`,
      color: f,
      border: `${i(1)} solid transparent`
    } : {
      background: `var(--mantine-color-${o.color}-${o.shade})`,
      hover: `var(--mantine-color-${o.color}-${o.shade === 9 ? 8 : o.shade + 1})`,
      color: f,
      border: `${i(1)} solid transparent`
    } : {
      background: r,
      hover: z(r, 0.1),
      color: f,
      border: `${i(1)} solid transparent`
    };
  }
  if (t === "light") {
    if (o.isThemeColor) {
      if (o.shade === void 0)
        return {
          background: `var(--mantine-color-${r}-light)`,
          hover: `var(--mantine-color-${r}-light-hover)`,
          color: `var(--mantine-color-${r}-light-color)`,
          border: `${i(1)} solid transparent`
        };
      const f = e.colors[o.color][o.shade];
      return {
        background: g(f, 0.1),
        hover: g(f, 0.12),
        color: `var(--mantine-color-${o.color}-${Math.min(o.shade, 6)})`,
        border: `${i(1)} solid transparent`
      };
    }
    return {
      background: g(r, 0.1),
      hover: g(r, 0.12),
      color: r,
      border: `${i(1)} solid transparent`
    };
  }
  if (t === "outline")
    return o.isThemeColor ? o.shade === void 0 ? {
      background: "transparent",
      hover: `var(--mantine-color-${r}-outline-hover)`,
      color: `var(--mantine-color-${r}-outline)`,
      border: `${i(1)} solid var(--mantine-color-${r}-outline)`
    } : {
      background: "transparent",
      hover: g(e.colors[o.color][o.shade], 0.05),
      color: `var(--mantine-color-${o.color}-${o.shade})`,
      border: `${i(1)} solid var(--mantine-color-${o.color}-${o.shade})`
    } : {
      background: "transparent",
      hover: g(r, 0.05),
      color: r,
      border: `${i(1)} solid ${r}`
    };
  if (t === "subtle") {
    if (o.isThemeColor) {
      if (o.shade === void 0)
        return {
          background: "transparent",
          hover: `var(--mantine-color-${r}-light-hover)`,
          color: `var(--mantine-color-${r}-light-color)`,
          border: `${i(1)} solid transparent`
        };
      const f = e.colors[o.color][o.shade];
      return {
        background: "transparent",
        hover: g(f, 0.12),
        color: `var(--mantine-color-${o.color}-${Math.min(o.shade, 6)})`,
        border: `${i(1)} solid transparent`
      };
    }
    return {
      background: "transparent",
      hover: g(r, 0.12),
      color: r,
      border: `${i(1)} solid transparent`
    };
  }
  return t === "transparent" ? o.isThemeColor ? o.shade === void 0 ? {
    background: "transparent",
    hover: "transparent",
    color: `var(--mantine-color-${r}-light-color)`,
    border: `${i(1)} solid transparent`
  } : {
    background: "transparent",
    hover: "transparent",
    color: `var(--mantine-color-${o.color}-${Math.min(o.shade, 6)})`,
    border: `${i(1)} solid transparent`
  } : {
    background: "transparent",
    hover: "transparent",
    color: r,
    border: `${i(1)} solid transparent`
  } : t === "white" ? o.isThemeColor ? o.shade === void 0 ? {
    background: "var(--mantine-color-white)",
    hover: z(e.white, 0.01),
    color: `var(--mantine-color-${r}-filled)`,
    border: `${i(1)} solid transparent`
  } : {
    background: "var(--mantine-color-white)",
    hover: z(e.white, 0.01),
    color: `var(--mantine-color-${o.color}-${o.shade})`,
    border: `${i(1)} solid transparent`
  } : {
    background: "var(--mantine-color-white)",
    hover: z(e.white, 0.01),
    color: r,
    border: `${i(1)} solid transparent`
  } : t === "gradient" ? {
    background: tr(n, e),
    hover: tr(n, e),
    color: "var(--mantine-color-white)",
    border: "none"
  } : t === "default" ? {
    background: "var(--mantine-color-default)",
    hover: "var(--mantine-color-default-hover)",
    color: "var(--mantine-color-default-color)",
    border: `${i(1)} solid var(--mantine-color-default-border)`
  } : {};
}, ue = {
  dark: [
    "#C9C9C9",
    "#b8b8b8",
    "#828282",
    "#696969",
    "#424242",
    "#3b3b3b",
    "#2e2e2e",
    "#242424",
    "#1f1f1f",
    "#141414"
  ],
  gray: [
    "#f8f9fa",
    "#f1f3f5",
    "#e9ecef",
    "#dee2e6",
    "#ced4da",
    "#adb5bd",
    "#868e96",
    "#495057",
    "#343a40",
    "#212529"
  ],
  red: [
    "#fff5f5",
    "#ffe3e3",
    "#ffc9c9",
    "#ffa8a8",
    "#ff8787",
    "#ff6b6b",
    "#fa5252",
    "#f03e3e",
    "#e03131",
    "#c92a2a"
  ],
  pink: [
    "#fff0f6",
    "#ffdeeb",
    "#fcc2d7",
    "#faa2c1",
    "#f783ac",
    "#f06595",
    "#e64980",
    "#d6336c",
    "#c2255c",
    "#a61e4d"
  ],
  grape: [
    "#f8f0fc",
    "#f3d9fa",
    "#eebefa",
    "#e599f7",
    "#da77f2",
    "#cc5de8",
    "#be4bdb",
    "#ae3ec9",
    "#9c36b5",
    "#862e9c"
  ],
  violet: [
    "#f3f0ff",
    "#e5dbff",
    "#d0bfff",
    "#b197fc",
    "#9775fa",
    "#845ef7",
    "#7950f2",
    "#7048e8",
    "#6741d9",
    "#5f3dc4"
  ],
  indigo: [
    "#edf2ff",
    "#dbe4ff",
    "#bac8ff",
    "#91a7ff",
    "#748ffc",
    "#5c7cfa",
    "#4c6ef5",
    "#4263eb",
    "#3b5bdb",
    "#364fc7"
  ],
  blue: [
    "#e7f5ff",
    "#d0ebff",
    "#a5d8ff",
    "#74c0fc",
    "#4dabf7",
    "#339af0",
    "#228be6",
    "#1c7ed6",
    "#1971c2",
    "#1864ab"
  ],
  cyan: [
    "#e3fafc",
    "#c5f6fa",
    "#99e9f2",
    "#66d9e8",
    "#3bc9db",
    "#22b8cf",
    "#15aabf",
    "#1098ad",
    "#0c8599",
    "#0b7285"
  ],
  teal: [
    "#e6fcf5",
    "#c3fae8",
    "#96f2d7",
    "#63e6be",
    "#38d9a9",
    "#20c997",
    "#12b886",
    "#0ca678",
    "#099268",
    "#087f5b"
  ],
  green: [
    "#ebfbee",
    "#d3f9d8",
    "#b2f2bb",
    "#8ce99a",
    "#69db7c",
    "#51cf66",
    "#40c057",
    "#37b24d",
    "#2f9e44",
    "#2b8a3e"
  ],
  lime: [
    "#f4fce3",
    "#e9fac8",
    "#d8f5a2",
    "#c0eb75",
    "#a9e34b",
    "#94d82d",
    "#82c91e",
    "#74b816",
    "#66a80f",
    "#5c940d"
  ],
  yellow: [
    "#fff9db",
    "#fff3bf",
    "#ffec99",
    "#ffe066",
    "#ffd43b",
    "#fcc419",
    "#fab005",
    "#f59f00",
    "#f08c00",
    "#e67700"
  ],
  orange: [
    "#fff4e6",
    "#ffe8cc",
    "#ffd8a8",
    "#ffc078",
    "#ffa94d",
    "#ff922b",
    "#fd7e14",
    "#f76707",
    "#e8590c",
    "#d9480f"
  ]
}, nr = "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji", dr = {
  scale: 1,
  fontSmoothing: !0,
  focusRing: "auto",
  white: "#fff",
  black: "#000",
  colors: ue,
  primaryShade: { light: 6, dark: 8 },
  primaryColor: "blue",
  variantColorResolver: de,
  autoContrast: !1,
  luminanceThreshold: 0.3,
  fontFamily: nr,
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
  respectReducedMotion: !1,
  cursorType: "default",
  defaultGradient: { from: "blue", to: "cyan", deg: 45 },
  defaultRadius: "sm",
  activeClassName: "mantine-active",
  focusClassName: "",
  headings: {
    fontFamily: nr,
    fontWeight: "700",
    textWrap: "wrap",
    sizes: {
      h1: { fontSize: i(34), lineHeight: "1.3" },
      h2: { fontSize: i(26), lineHeight: "1.35" },
      h3: { fontSize: i(22), lineHeight: "1.4" },
      h4: { fontSize: i(18), lineHeight: "1.45" },
      h5: { fontSize: i(16), lineHeight: "1.5" },
      h6: { fontSize: i(14), lineHeight: "1.5" }
    }
  },
  fontSizes: {
    xs: i(12),
    sm: i(14),
    md: i(16),
    lg: i(18),
    xl: i(20)
  },
  lineHeights: {
    xs: "1.4",
    sm: "1.45",
    md: "1.55",
    lg: "1.6",
    xl: "1.65"
  },
  radius: {
    xs: i(2),
    sm: i(4),
    md: i(8),
    lg: i(16),
    xl: i(32)
  },
  spacing: {
    xs: i(10),
    sm: i(12),
    md: i(16),
    lg: i(20),
    xl: i(32)
  },
  breakpoints: {
    xs: "36em",
    sm: "48em",
    md: "62em",
    lg: "75em",
    xl: "88em"
  },
  shadows: {
    xs: `0 ${i(1)} ${i(3)} rgba(0, 0, 0, 0.05), 0 ${i(1)} ${i(2)} rgba(0, 0, 0, 0.1)`,
    sm: `0 ${i(1)} ${i(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${i(10)} ${i(
      15
    )} ${i(-5)}, rgba(0, 0, 0, 0.04) 0 ${i(7)} ${i(7)} ${i(-5)}`,
    md: `0 ${i(1)} ${i(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${i(20)} ${i(
      25
    )} ${i(-5)}, rgba(0, 0, 0, 0.04) 0 ${i(10)} ${i(10)} ${i(-5)}`,
    lg: `0 ${i(1)} ${i(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${i(28)} ${i(
      23
    )} ${i(-7)}, rgba(0, 0, 0, 0.04) 0 ${i(12)} ${i(12)} ${i(-7)}`,
    xl: `0 ${i(1)} ${i(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${i(36)} ${i(
      28
    )} ${i(-7)}, rgba(0, 0, 0, 0.04) 0 ${i(17)} ${i(17)} ${i(-7)}`
  },
  other: {},
  components: {}
}, me = "[@mantine/core] MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more – https://mantine.dev/theming/colors/#primary-color", or = "[@mantine/core] MantineProvider: Invalid theme.primaryShade, it accepts only 0-9 integers or an object { light: 0-9, dark: 0-9 }";
function W(r) {
  return r < 0 || r > 9 ? !1 : parseInt(r.toString(), 10) === r;
}
function ir(r) {
  if (!(r.primaryColor in r.colors))
    throw new Error(me);
  if (typeof r.primaryShade == "object" && (!W(r.primaryShade.dark) || !W(r.primaryShade.light)))
    throw new Error(or);
  if (typeof r.primaryShade == "number" && !W(r.primaryShade))
    throw new Error(or);
}
function ye(r, e) {
  var n;
  if (!e)
    return ir(r), r;
  const t = cr(r, e);
  return e.fontFamily && !((n = e.headings) != null && n.fontFamily) && (t.headings.fontFamily = e.fontFamily), ir(t), t;
}
const U = fr(null), ge = () => V(U) || dr;
function ur() {
  const r = V(U);
  if (!r)
    throw new Error(
      "@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app"
    );
  return r;
}
function be({
  theme: r,
  children: e,
  inherit: t = !0
}) {
  const n = ge(), a = Yr(
    () => ye(t ? n : dr, r),
    [r, n, t]
  );
  return /* @__PURE__ */ $(U.Provider, { value: a, children: e });
}
be.displayName = "@mantine/core/MantineThemeProvider";
function rt(r, e, t) {
  var s;
  const n = ur(), a = (s = n.components[r]) == null ? void 0 : s.defaultProps, o = typeof a == "function" ? a(n) : a;
  return p(p(p({}, e), o), pr(t));
}
function B(r) {
  return q(r).reduce(
    (e, t) => r[t] !== void 0 ? `${e}${Jr(t)}:${r[t]};` : e,
    ""
  ).trim();
}
function he({ selector: r, styles: e, media: t, container: n }) {
  const a = e ? B(e) : "", o = Array.isArray(t) ? t.map((f) => `@media${f.query}{${r}{${B(f.styles)}}}`) : [], s = Array.isArray(n) ? n.map(
    (f) => `@container ${f.query}{${r}{${B(f.styles)}}}`
  ) : [];
  return `${a ? `${r}{${a}}` : ""}${o.join("")}${s.join("")}`.trim();
}
function $e(r) {
  const e = ne();
  return /* @__PURE__ */ $(
    "style",
    {
      "data-mantine-styles": "inline",
      nonce: e == null ? void 0 : e(),
      dangerouslySetInnerHTML: { __html: he(r) }
    }
  );
}
function ve(r) {
  const K = r, {
    m: e,
    mx: t,
    my: n,
    mt: a,
    mb: o,
    ml: s,
    mr: f,
    me: c,
    ms: l,
    p: y,
    px: d,
    py: u,
    pt: m,
    pb: j,
    pl: Y,
    pr: C,
    pe: k,
    ps: H,
    bd: w,
    bg: L,
    c: v,
    opacity: P,
    ff: M,
    fz: h,
    fw: R,
    lts: T,
    ta: br,
    lh: hr,
    fs: $r,
    tt: vr,
    td: xr,
    w: Sr,
    miw: Cr,
    maw: kr,
    h: wr,
    mih: Mr,
    mah: Rr,
    bgsz: Tr,
    bgp: Er,
    bgr: Ar,
    bga: zr,
    pos: Ir,
    top: _r,
    left: jr,
    bottom: Hr,
    right: Lr,
    inset: Pr,
    display: Fr,
    flex: Nr,
    hiddenFrom: Wr,
    visibleFrom: Br,
    lightHidden: Or,
    darkHidden: Dr,
    sx: Vr
  } = K, qr = A(K, [
    "m",
    "mx",
    "my",
    "mt",
    "mb",
    "ml",
    "mr",
    "me",
    "ms",
    "p",
    "px",
    "py",
    "pt",
    "pb",
    "pl",
    "pr",
    "pe",
    "ps",
    "bd",
    "bg",
    "c",
    "opacity",
    "ff",
    "fz",
    "fw",
    "lts",
    "ta",
    "lh",
    "fs",
    "tt",
    "td",
    "w",
    "miw",
    "maw",
    "h",
    "mih",
    "mah",
    "bgsz",
    "bgp",
    "bgr",
    "bga",
    "pos",
    "top",
    "left",
    "bottom",
    "right",
    "inset",
    "display",
    "flex",
    "hiddenFrom",
    "visibleFrom",
    "lightHidden",
    "darkHidden",
    "sx"
  ]);
  return { styleProps: pr({
    m: e,
    mx: t,
    my: n,
    mt: a,
    mb: o,
    ml: s,
    mr: f,
    me: c,
    ms: l,
    p: y,
    px: d,
    py: u,
    pt: m,
    pb: j,
    pl: Y,
    pr: C,
    pe: k,
    ps: H,
    bd: w,
    bg: L,
    c: v,
    opacity: P,
    ff: M,
    fz: h,
    fw: R,
    lts: T,
    ta: br,
    lh: hr,
    fs: $r,
    tt: vr,
    td: xr,
    w: Sr,
    miw: Cr,
    maw: kr,
    h: wr,
    mih: Mr,
    mah: Rr,
    bgsz: Tr,
    bgp: Er,
    bgr: Ar,
    bga: zr,
    pos: Ir,
    top: _r,
    left: jr,
    bottom: Hr,
    right: Lr,
    inset: Pr,
    display: Fr,
    flex: Nr,
    hiddenFrom: Wr,
    visibleFrom: Br,
    lightHidden: Or,
    darkHidden: Dr,
    sx: Vr
  }), rest: qr };
}
const xe = {
  m: { type: "spacing", property: "margin" },
  mt: { type: "spacing", property: "marginTop" },
  mb: { type: "spacing", property: "marginBottom" },
  ml: { type: "spacing", property: "marginLeft" },
  mr: { type: "spacing", property: "marginRight" },
  ms: { type: "spacing", property: "marginInlineStart" },
  me: { type: "spacing", property: "marginInlineEnd" },
  mx: { type: "spacing", property: "marginInline" },
  my: { type: "spacing", property: "marginBlock" },
  p: { type: "spacing", property: "padding" },
  pt: { type: "spacing", property: "paddingTop" },
  pb: { type: "spacing", property: "paddingBottom" },
  pl: { type: "spacing", property: "paddingLeft" },
  pr: { type: "spacing", property: "paddingRight" },
  ps: { type: "spacing", property: "paddingInlineStart" },
  pe: { type: "spacing", property: "paddingInlineEnd" },
  px: { type: "spacing", property: "paddingInline" },
  py: { type: "spacing", property: "paddingBlock" },
  bd: { type: "border", property: "border" },
  bg: { type: "color", property: "background" },
  c: { type: "textColor", property: "color" },
  opacity: { type: "identity", property: "opacity" },
  ff: { type: "fontFamily", property: "fontFamily" },
  fz: { type: "fontSize", property: "fontSize" },
  fw: { type: "identity", property: "fontWeight" },
  lts: { type: "size", property: "letterSpacing" },
  ta: { type: "identity", property: "textAlign" },
  lh: { type: "lineHeight", property: "lineHeight" },
  fs: { type: "identity", property: "fontStyle" },
  tt: { type: "identity", property: "textTransform" },
  td: { type: "identity", property: "textDecoration" },
  w: { type: "spacing", property: "width" },
  miw: { type: "spacing", property: "minWidth" },
  maw: { type: "spacing", property: "maxWidth" },
  h: { type: "spacing", property: "height" },
  mih: { type: "spacing", property: "minHeight" },
  mah: { type: "spacing", property: "maxHeight" },
  bgsz: { type: "size", property: "backgroundSize" },
  bgp: { type: "identity", property: "backgroundPosition" },
  bgr: { type: "identity", property: "backgroundRepeat" },
  bga: { type: "identity", property: "backgroundAttachment" },
  pos: { type: "identity", property: "position" },
  top: { type: "size", property: "top" },
  left: { type: "size", property: "left" },
  bottom: { type: "size", property: "bottom" },
  right: { type: "size", property: "right" },
  inset: { type: "size", property: "inset" },
  display: { type: "identity", property: "display" },
  flex: { type: "identity", property: "flex" }
};
function X(r, e) {
  const t = _({ color: r, theme: e });
  return t.color === "dimmed" ? "var(--mantine-color-dimmed)" : t.color === "bright" ? "var(--mantine-color-bright)" : t.variable ? `var(${t.variable})` : t.color;
}
function Se(r, e) {
  const t = _({ color: r, theme: e });
  return t.isThemeColor && t.shade === void 0 ? `var(--mantine-color-${t.color}-text)` : X(r, e);
}
function Ce(r, e) {
  if (typeof r == "number")
    return i(r);
  if (typeof r == "string") {
    const [t, n, ...a] = r.split(" ").filter((s) => s.trim() !== "");
    let o = `${i(t)}`;
    return n && (o += ` ${n}`), a.length > 0 && (o += ` ${X(a.join(" "), e)}`), o.trim();
  }
  return r;
}
const ar = {
  text: "var(--mantine-font-family)",
  mono: "var(--mantine-font-family-monospace)",
  monospace: "var(--mantine-font-family-monospace)",
  heading: "var(--mantine-font-family-headings)",
  headings: "var(--mantine-font-family-headings)"
};
function ke(r) {
  return typeof r == "string" && r in ar ? ar[r] : r;
}
const we = ["h1", "h2", "h3", "h4", "h5", "h6"];
function Me(r, e) {
  return typeof r == "string" && r in e.fontSizes ? `var(--mantine-font-size-${r})` : typeof r == "string" && we.includes(r) ? `var(--mantine-${r}-font-size)` : typeof r == "number" ? i(r) : typeof r == "string" ? i(r) : r;
}
function Re(r) {
  return r;
}
const Te = ["h1", "h2", "h3", "h4", "h5", "h6"];
function Ee(r, e) {
  return typeof r == "string" && r in e.lineHeights ? `var(--mantine-line-height-${r})` : typeof r == "string" && Te.includes(r) ? `var(--mantine-${r}-line-height)` : r;
}
function Ae(r) {
  return typeof r == "number" ? i(r) : r;
}
function ze(r, e) {
  if (typeof r == "number")
    return i(r);
  if (typeof r == "string") {
    const t = r.replace("-", "");
    if (!(t in e.spacing))
      return i(r);
    const n = `--mantine-spacing-${t}`;
    return r.startsWith("-") ? `calc(var(${n}) * -1)` : `var(${n})`;
  }
  return r;
}
const O = {
  color: X,
  textColor: Se,
  fontSize: Me,
  spacing: ze,
  identity: Re,
  size: Ae,
  lineHeight: Ee,
  fontFamily: ke,
  border: Ce
};
function sr(r) {
  return r.replace("(min-width: ", "").replace("em)", "");
}
function Ie(t) {
  var n = t, {
    media: r
  } = n, e = A(n, [
    "media"
  ]);
  const o = Object.keys(r).sort((s, f) => Number(sr(s)) - Number(sr(f))).map((s) => ({ query: s, styles: r[s] }));
  return x(p({}, e), { media: o });
}
function _e(r) {
  if (typeof r != "object" || r === null)
    return !1;
  const e = Object.keys(r);
  return !(e.length === 1 && e[0] === "base");
}
function je(r) {
  return typeof r == "object" && r !== null ? "base" in r ? r.base : void 0 : r;
}
function He(r) {
  return typeof r == "object" && r !== null ? q(r).filter((e) => e !== "base") : [];
}
function Le(r, e) {
  return typeof r == "object" && r !== null && e in r ? r[e] : r;
}
function Pe({
  styleProps: r,
  data: e,
  theme: t
}) {
  return Ie(
    q(r).reduce(
      (n, a) => {
        if (a === "hiddenFrom" || a === "visibleFrom" || a === "sx")
          return n;
        const o = e[a], s = Array.isArray(o.property) ? o.property : [o.property], f = je(r[a]);
        if (!_e(r[a]))
          return s.forEach((l) => {
            n.inlineStyles[l] = O[o.type](f, t);
          }), n;
        n.hasResponsiveStyles = !0;
        const c = He(r[a]);
        return s.forEach((l) => {
          f && (n.styles[l] = O[o.type](f, t)), c.forEach((y) => {
            const d = `(min-width: ${t.breakpoints[y]})`;
            n.media[d] = x(p({}, n.media[d]), {
              [l]: O[o.type](
                Le(r[a], y),
                t
              )
            });
          });
        }), n;
      },
      {
        hasResponsiveStyles: !1,
        styles: {},
        inlineStyles: {},
        media: {}
      }
    )
  );
}
function Fe() {
  return `__m__-${Kr().replace(/:/g, "")}`;
}
function et(r) {
  return r;
}
function mr(r) {
  return r.startsWith("data-") ? r : `data-${r}`;
}
function Ne(r) {
  return Object.keys(r).reduce((e, t) => {
    const n = r[t];
    return n === void 0 || n === "" || n === !1 || n === null || (e[mr(t)] = r[t]), e;
  }, {});
}
function yr(r) {
  return r ? typeof r == "string" ? { [mr(r)]: !0 } : Array.isArray(r) ? [...r].reduce(
    (e, t) => p(p({}, e), yr(t)),
    {}
  ) : Ne(r) : null;
}
function D(r, e) {
  return Array.isArray(r) ? [...r].reduce(
    (t, n) => p(p({}, t), D(n, e)),
    {}
  ) : typeof r == "function" ? r(e) : r == null ? {} : r;
}
function We({
  theme: r,
  style: e,
  vars: t,
  styleProps: n
}) {
  const a = D(e, r), o = D(t, r);
  return p(p(p({}, a), o), n);
}
const gr = I(
  (Y, j) => {
    var C = Y, {
      component: r,
      style: e,
      __vars: t,
      className: n,
      variant: a,
      mod: o,
      size: s,
      hiddenFrom: f,
      visibleFrom: c,
      lightHidden: l,
      darkHidden: y,
      renderRoot: d,
      __size: u
    } = C, m = A(C, [
      "component",
      "style",
      "__vars",
      "className",
      "variant",
      "mod",
      "size",
      "hiddenFrom",
      "visibleFrom",
      "lightHidden",
      "darkHidden",
      "renderRoot",
      "__size"
    ]);
    var T;
    const k = ur(), H = r || "div", { styleProps: w, rest: L } = ve(m), v = oe(), P = (T = v == null ? void 0 : v()) == null ? void 0 : T(w.sx), M = Fe(), h = Pe({
      styleProps: w,
      theme: k,
      data: xe
    }), R = p(p({
      ref: j,
      style: We({
        theme: k,
        style: e,
        vars: t,
        styleProps: h.inlineStyles
      }),
      className: ee(n, P, {
        [M]: h.hasResponsiveStyles,
        "mantine-light-hidden": l,
        "mantine-dark-hidden": y,
        [`mantine-hidden-from-${f}`]: f,
        [`mantine-visible-from-${c}`]: c
      }),
      "data-variant": a,
      "data-size": re(s) ? void 0 : s || void 0,
      size: u
    }, yr(o)), L);
    return /* @__PURE__ */ Qr(Zr, { children: [
      h.hasResponsiveStyles && /* @__PURE__ */ $(
        $e,
        {
          selector: `.${M}`,
          styles: h.styles,
          media: h.media
        }
      ),
      typeof d == "function" ? d(R) : /* @__PURE__ */ $(H, p({}, R))
    ] });
  }
);
gr.displayName = "@mantine/core/Box";
const tt = gr;
function Be(r) {
  return r;
}
function nt(r) {
  const e = r;
  return (t) => {
    const n = I((a, o) => /* @__PURE__ */ $(e, x(p(p({}, t), a), { ref: o })));
    return n.extend = e.extend, n.displayName = `WithProps(${e.displayName})`, n;
  };
}
function ot(r) {
  const e = I(r);
  return e.extend = Be, e.withProps = (t) => {
    const n = I((a, o) => /* @__PURE__ */ $(e, x(p(p({}, t), a), { ref: o })));
    return n.extend = e.extend, n.displayName = `WithProps(${e.displayName})`, n;
  }, e;
}
export {
  Ue as A,
  tt as B,
  be as C,
  dr as D,
  $e as I,
  te as M,
  Be as a,
  ur as b,
  ee as c,
  et as d,
  ve as e,
  ot as f,
  ce as g,
  er as h,
  re as i,
  tr as j,
  Ze as k,
  Fe as l,
  Pe as m,
  pr as n,
  q as o,
  _ as p,
  nt as q,
  g as r,
  Qe as s,
  Xe as t,
  rt as u,
  Ye as v,
  Ke as w,
  ne as x,
  Je as y,
  cr as z
};
